module.exports = __webpack_public_path__ + "static/media/gallery.8dec58db.png";